var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext } from "react";
import axios from "axios";
import { MainContext } from "../context/MainContext";
import useLocation from "./useLocation";
import useDeviceDetect from "./useDeviceDetect";
import constants, { KEY_LOCAL_STORAGE } from "../constants";
import { API_URL } from "../helpers/hostHelper";
var useValidation = function () {
    var _a = useContext(MainContext), setApiKey = _a.setApiKey, tracking = _a.tracking, usageType = _a.usageType;
    var handleGeolocation = useLocation().handleGeolocation;
    var isTraceData = useDeviceDetect().isTraceData;
    var setTokenProcess = function (token) {
        if (typeof window !== "undefined") {
            localStorage.setItem(KEY_LOCAL_STORAGE, token);
        }
    };
    var getTokenProcess = function () {
        if (typeof window !== "undefined") {
            return localStorage.getItem(KEY_LOCAL_STORAGE);
        }
        return null;
    };
    var getTokenValidation = function (token, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    if (!API_URL)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, axios.get("".concat(API_URL, "/button"), {
                            headers: {
                                "x-api-key": apiKey,
                            },
                            params: {
                                token: token,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_1 = _a.sent();
                    console.log(error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getExternalTokenValidation = function (token) { return __awaiter(void 0, void 0, void 0, function () {
        var decoded, decodedArray, apiKey, apiSecret, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    decoded = atob(token);
                    decodedArray = decoded.split("+");
                    apiKey = decodedArray[0];
                    setApiKey(apiKey);
                    apiSecret = decodedArray[1];
                    if (!API_URL)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, axios.post("".concat(API_URL, "/auth/attempt/client"), {
                            api_key_64: btoa(apiKey),
                            api_secret_64: btoa(apiSecret),
                        }, {
                            headers: {
                                "x-api-key": apiKey,
                            },
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_2 = _a.sent();
                    console.log(error_2);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var sendLifetestUsage = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var response, error_3;
        var body = _b.body, apiKey = _b.apiKey;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    if (!API_URL)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, axios.post("".concat(API_URL, "/lifetest/usage"), body, {
                            headers: {
                                "x-api-key": apiKey,
                            },
                        })];
                case 1:
                    response = _c.sent();
                    return [2 /*return*/, response.data.data];
                case 2:
                    error_3 = _c.sent();
                    console.error(error_3);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var setEvent = function (event, apiKey) { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, tokenProcess, location_1, body, response, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    if (!(tracking !== "disabled")) return [3 /*break*/, 4];
                    if (!(event === constants.START)) return [3 /*break*/, 2];
                    return [4 /*yield*/, sendLifetestUsage({
                            body: {
                                kind: event,
                                comment: "",
                                usage_type: usageType,
                            },
                            apiKey: apiKey,
                        })];
                case 1:
                    response_1 = _a.sent();
                    setTokenProcess(response_1 === null || response_1 === void 0 ? void 0 : response_1.token);
                    return [3 /*break*/, 4];
                case 2:
                    tokenProcess = getTokenProcess();
                    return [4 /*yield*/, sendLifetestUsage({
                            body: {
                                kind: event,
                                comment: "",
                                Token: tokenProcess,
                                usage_type: usageType,
                            },
                            apiKey: apiKey,
                        })];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, handleGeolocation()];
                case 5:
                    location_1 = _a.sent();
                    body = __assign(__assign({}, location_1), isTraceData);
                    if (!API_URL)
                        return [2 /*return*/, null];
                    return [4 /*yield*/, axios.post("".concat(API_URL, "/tool/event"), {
                            tool_name: "FaceTec",
                            event: event,
                            data: JSON.stringify(body),
                        }, {
                            headers: {
                                "x-api-key": apiKey,
                            },
                        })];
                case 6:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 7:
                    error_4 = _a.sent();
                    console.log(error_4);
                    return [2 /*return*/, null];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    return {
        getTokenValidation: getTokenValidation,
        getExternalTokenValidation: getExternalTokenValidation,
        setEvent: setEvent,
        setTokenProcess: setTokenProcess,
        getTokenProcess: getTokenProcess,
    };
};
export default useValidation;
